import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-dates/initialize';
import moment from 'moment';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/styles';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import InputAdornment from '@material-ui/core/InputAdornment';
import { getDate } from 'lib/commonLib';

import { makeRowColumn } from 'lib/commonLib';
import { mobonComCode } from 'lib/api/code';

import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import FilterCollection from 'components/organisms/FilterCollection';
import PresetSingleDate from 'components/organisms/DatePicker/PresetSingleDate.js';
import 'react-dates/lib/css/_datepicker.css';

const bankDepositStyle = makeStyles((theme) => ({
  form: {
    minHeight: 450,
    marginTop: 10,
    '& > table': {
      width: '100%',
      borderCollapse: 'collapse',
      '& > tbody > tr': {
        '& > th, & > td ': { borderBottom: '1px solid #000' },
        '& > td': { padding: 12 },
      },
    },
    '& .onCheck': {
      '& .DateInput_input': {
        border: '1px solid #f00 !important',
      },
    },
    '& .SingleDatePicker': {
      '& .SingleDatePickerInput': { border: 0, borderRadius: 0 },
      '& .DateInput ': {
        width: '100%',
        maxWidth: '100% !important',
      },
      '& .DateInput_input': {
        width: '170px !important',
        textAlign: 'center',
        padding: '5px 10px 5px',
        border: '1px solid #e8e9ec',
        borderRadius: 4,
        fontSize: 14,
        lineHeight: 'initial',
        boxSizing: 'border-box',
      },
    },
  },
  verticalTop: {
    '& > th': { paddingTop: 14, verticalAlign: 'top' },
    '& > td > div': { marginBottom: 10, '&:last-child': { marginBottom: 0 } },
  },
  refundBox: {
    borderBottom: '1px solid ' + theme.palette.common.gray2,
    '& > div': {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '0 0 5px 0',
      '& > p': { margin: '8px 0' },
    },
  },
  refundHead: { fontWeight: 'bold', fontSize: 16 },
  refundInputBox: {
    display: 'flex',
    alignItems: 'center',
    width: 180,
    justifyContent: 'space-between',
  },
  inputRight: { '& input': { textAlign: 'right' } },
}));

const ChargeBox = (props) => {
  const { modal, params, getParams, chargingType, error } = props;
  const classes = bankDepositStyle();
  const { t } = useTranslation();

  const { reloadPoint, balancePoint, agencyFee, placeboFee } = modal.params;

  const [resultAmt, setResultAmt] = useState(0);
  const [dedAmt, setDedAmt] = useState(0);
  const [exhsFee, setExhsFee] = useState(0);
  const [uexhsFee, setUexhsFee] = useState(0);
  const [penaltyAmt, setPenaltyAmt] = useState(0);
  const [refundAmt, setRefundAmt] = useState(0);
  const [restRsnCodeList, setRestRsnCodeList] = useState([]);
  const [dtlRestRsnCodeList, setDtlRestRsnCodeList] = useState([]);
  const timeList = [
    { value: '00', label: '00시' },
    { value: '01', label: '01시' },
    { value: '02', label: '02시' },
    { value: '03', label: '03시' },
    { value: '04', label: '04시' },
    { value: '05', label: '05시' },
    { value: '06', label: '06시' },
    { value: '07', label: '07시' },
    { value: '08', label: '08시' },
    { value: '09', label: '09시' },
    { value: '10', label: '10시' },
    { value: '11', label: '11시' },
    { value: '12', label: '12시' },
    { value: '13', label: '13시' },
    { value: '14', label: '14시' },
    { value: '15', label: '15시' },
    { value: '16', label: '16시' },
    { value: '17', label: '17시' },
    { value: '18', label: '18시' },
    { value: '19', label: '19시' },
    { value: '20', label: '20시' },
    { value: '21', label: '21시' },
    { value: '22', label: '22시' },
    { value: '23', label: '23시' },
  ];

  const weekList = [
    { value: '01', label: '월요일' },
    { value: '02', label: '화요일' },
    { value: '03', label: '수요일' },
    { value: '04', label: '목요일' },
    { value: '05', label: '금요일' },
    { value: '06', label: '토요일' },
    { value: '07', label: '일요일' },
  ];

  //대행사리스트
  const agencyList = modal.agencyList;

  //보너스충전 -> 선불예약리스트
  const prePayReserveList = modal.prePayReserveList;

  //보너스충전 -> 후불예약리스트
  const payLaterReserveList = modal.payLaterReserveList;

  useEffect(() => {
    if (
      modal.type === 'payRefund' ||
      modal.type === 'cardRefund' ||
      modal.type === 'tossPayRefund' ||
      modal.type === 'tossCardRefund'
    ) {
      let newAmt = resultAmt;
      let newDedAmt = 0;
      let newExhsFee = exhsFee;
      let newUexhsFee = uexhsFee;
      let newPenaltyAmt = penaltyAmt;
      let newRefundAmt = refundAmt;

      if (!!reloadPoint && !!balancePoint) {
        const reloadPointNum = parseInt(reloadPoint.replace(/,/g, ''), 10);
        const balancePointNum = parseInt(balancePoint.replace(/,/g, ''), 10);
        const newAmt = reloadPointNum - balancePointNum;

        setResultAmt(newAmt);
      }
      if (!!agencyFee) {
        // 소진 비용의 1%
        newExhsFee = newAmt * agencyFee * 0.01;
        newUexhsFee =
          parseInt(balancePoint.replace(/,/g, ''), 10) * agencyFee * 0.01;
        setExhsFee(newExhsFee);
        setUexhsFee(newUexhsFee);
        newDedAmt = newExhsFee + newUexhsFee + newPenaltyAmt;

        setDedAmt(newDedAmt);
      } else {
        setExhsFee(0);
        setUexhsFee(0);
        setDedAmt(0);
      }
      if (!!placeboFee) {
        newPenaltyAmt =
          parseInt(balancePoint.replace(/,/g, ''), 10) * placeboFee * 0.01;
        setPenaltyAmt(newPenaltyAmt);
        newRefundAmt =
          parseInt(balancePoint.replace(/,/g, ''), 10) - newPenaltyAmt;
        setRefundAmt(newRefundAmt);
      } else {
        setPenaltyAmt(0);
        setRefundAmt(0);
      }
    }
    // eslint-disable-next-line
  }, [modal.params]);

  useEffect(() => {
    mobonComCode({codeTpId: 'REST_RSN_CODE'})
      .then((response) => {
        const { data } = response.data;
        setRestRsnCodeList(data);
      })
      .catch((error) => {});

    // 사유 항목 (상세) 리스트
    mobonComCode({codeTpId: 'DTL_REST_RSN_CODE'})
      .then((response) => {
        const { data } = response.data;
        setDtlRestRsnCodeList(data);
      })
      .catch((error) => {});
  }, []);

  //금액 추가 버튼
  const handlePrice = (price) => {
    const numericPayPoint = Number(params.payPoint.replace(/,/g, ''));
    getParams({
      ...params,
      payPoint:
        params.payPoint === '' ? price : parseInt(numericPayPoint) + price,
    });
  };

  const handleSingleDate = (newDate) => {
    getParams({ ...params, ...newDate });
  };

  return (
    <>
      <form className={classes.form} noValidate>
        <table>
          <tbody>
            <tr>
              <th>{t('광고주ID')}</th>
              <td>
                <NewInput
                  type="filter"
                  inputType="name"
                  name="userId"
                  params={modal.params}
                  value={modal.params.userId}
                  callBack={getParams}
                  error={error.userId}
                  helperText={error.userId && t('아이디를 입력해주세요.')}
                  disabled={chargingType !== 'reload' ? true : undefined}
                />
              </td>
            </tr>
            {chargingType !== 'reload' && (
              <tr>
                <th>{t('충전 일자')}</th>
                <td>
                  <div className={clsx('mb-DateRangePicker')}>
                    <PresetSingleDate
                      isOutsideRange={() => false}
                      displayFormat={'MMM DD일'}
                      id="date"
                      onDateChange={(newDate) => {
                        handleSingleDate({
                          date: getDate(newDate),
                        });
                      }}
                      numberOfMonths={1}
                      initialDate={
                        !!params['date']
                          ? moment(params['date'], 'YYYYMMDD')
                          : null
                      }
                      placeholder="날짜 선택"
                      monthFormat="MMMM YYYY"
                      error={error.date}
                    />
                  </div>
                </td>
              </tr>
            )}
            {chargingType !== 'payRefund' &&
              chargingType !== 'cardRefund' &&
              chargingType !== 'tossPayRefund' &&
              chargingType !== 'tossCardRefund' && (
                <>
                  <tr className={classes.verticalTop}>
                    <th>{t('충전 금액')}</th>
                    <td>
                      <div>
                        <NewInput
                          type="filter"
                          inputType="price"
                          name={
                            chargingType !== 'reload' ? 'payPoint' : 'payPoint'
                          }
                          params={modal.params}
                          value={modal.params.payPoint}
                          callBack={(newParams, type) => {
                            getParams(newParams, type);
                          }}
                          autoFocus
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {t('원')}
                              </InputAdornment>
                            ),
                          }}
                          error={error.payPoint}
                          helperText={
                            error.payPoint
                              ? t('금액을 입력해주세요.')
                              : chargingType !== 'reload'
                              ? '(vat 포함)'
                              : '(vat 미포함)'
                          }
                        />
                      </div>
                      {chargingType !== 'reload' && (
                        <div>
                          <ButtonGroup
                            style={{
                              width: 450,
                              justifyContent: 'space-between',
                            }}
                          >
                            <NewButton
                              value="330000"
                              name="payPoint"
                              onClick={() => handlePrice(330000)}
                            >
                              33{t('만원')}
                            </NewButton>
                            <NewButton
                              value="550000"
                              name="payPoint"
                              onClick={() => handlePrice(550000)}
                            >
                              55{t('만원')}
                            </NewButton>
                            <NewButton
                              value="1100000"
                              name="payPoint"
                              onClick={() => handlePrice(1100000)}
                            >
                              110{t('만원')}
                            </NewButton>
                            <NewButton
                              value="1650000"
                              name="payPoint"
                              onClick={() => handlePrice(1650000)}
                            >
                              165{t('만원')}
                            </NewButton>
                            <NewButton
                              value="2200000"
                              name="payPoint"
                              onClick={() => handlePrice(2200000)}
                            >
                              220{t('만원')}
                            </NewButton>
                            <NewButton
                              value=""
                              name="payPoint"
                              onClick={() =>
                                getParams({ ...params, payPoint: '0' })
                              }
                            >
                              {t('초기화')}
                            </NewButton>
                          </ButtonGroup>
                        </div>
                      )}
                    </td>
                  </tr>
                  {chargingType !== 'reload' && (
                    <tr>
                      <th>{t('입금자명')}</th>
                      <td>
                        <NewInput
                          type="filter"
                          inputType="name"
                          name="name"
                          params={modal.params}
                          value={modal.params.name}
                          callBack={getParams}
                          inputProps={{ maxLength: 20 }}
                          error={error.name}
                          helperText={
                            error.name && t('입금자명을 입력해주세요.')
                          }
                        />
                      </td>
                    </tr>
                  )}
                </>
              )}
            {(chargingType === 'payRefund' ||
              chargingType === 'cardRefund' ||
              chargingType === 'tossPayRefund' ||
              chargingType === 'tossCardRefund') && (
              <>
                <tr>
                  <th>{t('거래여부')}</th>
                  <td>
                    <FilterCollection
                      label={t('거래여부 선택')}
                      name="dealType"
                      params={params}
                      value={params.dealType}
                      type="select"
                      list={[
                        { value: '01', label: '거래유지' },
                        { value: '02', label: '거래안함' },
                        { value: '03', label: '직광고주' },
                      ]}
                      callBack={getParams}
                      labelKey="label"
                      valueKey="value"
                      error={error.dealType}
                      helperText={
                        error.dealType && t('거래여부를 선택해주세요.')
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <th>{t('내역')}</th>
                  <td>
                    <div className={classes.refundLayout}>
                      <div className={classes.refundBox}>
                        <div className={classes.refundHead}>
                          <p>{t('소진비용')} : </p>
                          <p>{makeRowColumn(resultAmt, 'number', '#,##0')}</p>
                        </div>
                        <div>
                          <p>{t('충전금액')} : </p>
                          <NewInput
                            type="filter"
                            inputType="price"
                            name="reloadPoint"
                            params={modal.params}
                            value={modal.params.reloadPoint}
                            callBack={getParams}
                            className={classes.inputRight}
                            error={error.reloadPoint}
                          />
                        </div>
                        <div>
                          <p>{t('남은금액')} : </p>
                          <NewInput
                            type="filter"
                            inputType="price"
                            name="balancePoint"
                            params={modal.params}
                            value={modal.params.balancePoint}
                            callBack={getParams}
                            className={classes.inputRight}
                            error={error.balancePoint}
                          />
                        </div>
                      </div>
                      <div className={classes.refundBox}>
                        <div className={classes.refundHead}>
                          <p>{t('차감금액')} : </p>
                          <p>
                            {makeRowColumn(dedAmt, 'number', '#,##0')}
                            {t('원')}
                          </p>
                        </div>
                        <div>
                          <p>{t('수수료율')} : </p>
                          <NewInput
                            type="filter"
                            inputType="name"
                            name="agencyFee"
                            params={modal.params}
                            value={modal.params.agencyFee}
                            callBack={getParams}
                            style={{ width: '80px', textAlign: 'right' }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  %
                                </InputAdornment>
                              ),
                              maxLength: 3,
                            }}
                            className={classes.inputRight}
                            disabled={
                              params.dealType === '03' ? true : undefined
                            }
                            error={error.agencyFee}
                          />
                        </div>
                        <div>
                          <p>{t('소진 대행사 수수료')} : </p>
                          <p>
                            - {makeRowColumn(exhsFee, 'number', '#,##0')}
                            {t('원')}
                          </p>
                        </div>
                        <div>
                          <p>{t('미소진 대행사 수수료')} : </p>
                          <p>
                            - {makeRowColumn(uexhsFee, 'number', '#,##0')}
                            {t('원')}
                          </p>
                        </div>
                        <div>
                          <p>{t('위약금')} : </p>
                          <div className={classes.refundInputBox}>
                            <p>
                              - {makeRowColumn(penaltyAmt, 'number', '#,##0')}
                              {t('원')}
                            </p>
                            <NewInput
                              type="filter"
                              inputType="name"
                              name="placeboFee"
                              params={modal.params}
                              value={modal.params.placeboFee}
                              callBack={getParams}
                              style={{ width: '80px' }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    %
                                  </InputAdornment>
                                ),
                                maxLength: 3,
                              }}
                              className={classes.inputRight}
                              error={error.placeboFee}
                            />
                          </div>
                        </div>
                      </div>
                      <div className={classes.refundBox}>
                        <div className={classes.refundHead}>
                          <p>{t('환불금액')} : </p>
                          <p>
                            {makeRowColumn(refundAmt, 'number', '#,##0')}
                            {t('원')}
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t('대행사')}</th>
                  <td>
                    <FilterCollection
                      label={t('대행사 선택')}
                      name="agency"
                      params={params}
                      value={params.agency}
                      type="select"
                      list={agencyList}
                      callBack={getParams}
                      labelKey="label"
                      valueKey="value"
                      disabled={params.dealType !== '03' ? false : true}
                      error={error.agency}
                      helperText={error.agency && t('대행사를 선택해주세요.')}
                    />
                  </td>
                </tr>
              </>
            )}
            {chargingType === 'reload' && (
              <>
                <tr>
                  <th>{t('사유')}</th>
                  <td>
                    <FilterCollection
                      label={t('사유 선택')}
                      name="restRsnCode"
                      params={params}
                      value={params.restRsnCode}
                      type="select"
                      list={restRsnCodeList}
                      callBack={getParams}
                      labelKey="CODE_VAL"
                      valueKey="CODE_ID"
                      error={error.restRsnCode}
                      helperText={
                          error.restRsnCode && t('사유를 선택해주세요.')
                      }
                    />
                  </td>
                </tr>
                {params.restRsnCode === '04' && (
                  <>
                    <tr>
                      <th>{t('사유 항목')}</th>
                      <td>
                        <FilterCollection
                          label={t('사유 항목 선택')}
                          name="dtlRestRsnCode"
                          params={params}
                          value={params.dtlRestRsnCode}
                          type="select"
                          list={dtlRestRsnCodeList}
                          callBack={getParams}
                          labelKey="CODE_VAL"
                          valueKey="CODE_ID"
                          error={error.dtlRestRsnCode}
                          helperText={error.dtlRestRsnCode && t('사유 항목을 선택해주세요')}
                        />
                      </td>
                    </tr>
                  </>
                )}
                {params.restRsnCode === '11' || params.restRsnCode === '13' ? (
                  <>
                    <tr>
                      <th>{t('등록리스트')}</th>
                      <td>
                        <FilterCollection
                          label={t('등록리스트')}
                          name={
                            params.restRsnCode === '11'
                              ? 'prePayReserve'
                              : 'payLaterReserve'
                          }
                          params={params}
                          value={
                            params.restRsnCode === '11'
                              ? params.prePayReserve
                              : params.payLaterReserve
                          }
                          type="select"
                          list={
                            params.restRsnCode === '11'
                              ? prePayReserveList
                              : payLaterReserveList
                          }
                          callBack={getParams}
                          labelKey="label"
                          valueKey="value"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th rowSpan={3}>{t('주 마다 반복')}</th>
                      <td>
                        <div className={clsx('mb-DateRangePicker')}>
                          <PresetSingleDate
                            isOutsideRange={() => false}
                            displayFormat={'MMM DD일'}
                            id="rsvDate"
                            onDateChange={(newDate) => {
                              handleSingleDate({
                                rsvDate: getDate(newDate),
                              });
                            }}
                            numberOfMonths={1}
                            initialDate={
                              !!params['rsvDate']
                                ? moment(params['rsvDate'], 'YYYYMMDD')
                                : null
                            }
                            placeholder="반복 종료 날짜"
                            monthFormat="MMMM YYYY"
                            disabled={
                              !!params.prePayReserve || params.payLaterReserve
                                ? true
                                : false
                            }
                          />
                          <span>(날짜 선택 안할 시 무제한 반복 됩니다.)</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FilterCollection
                          label={t('요일 설정')}
                          name="weekType"
                          params={params}
                          value={params.weekType}
                          type="checkbox"
                          list={weekList}
                          callBack={getParams}
                          labelKey="label"
                          valueKey="value"
                          error={error.weekType}
                          helperText={
                            error.weekType && t('요일을 선택해주세요')
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FilterCollection
                          label={t('시간 설정')}
                          name="rsvTime"
                          params={params}
                          value={params.rsvTime}
                          type="select"
                          list={timeList}
                          callBack={getParams}
                          labelKey="label"
                          valueKey="value"
                          disabled={
                            !!params.prePayReserve || params.payLaterReserve
                              ? true
                              : false
                          }
                          error={error.rsvTime}
                          helperText={error.rsvTime && t('시간을 선택해주세요')}
                        />
                      </td>
                    </tr>
                  </>
                ) : (
                  <tr>
                    <th>{t('메모')}</th>
                    <td>
                      <NewInput
                        type="filter"
                        inputType="name"
                        name="memo"
                        params={modal.params}
                        value={modal.params.memo}
                        callBack={getParams}
                        helperText={t('100자 이내')}
                        inputProps={{ maxLength: 100 }}
                        style={{ width: '100%' }}
                      />
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </form>
    </>
  );
};

export default ChargeBox;
